// NOTE: This should be the first statement of every entry file
import 'reflect-metadata';
// All other imports
import { createApp } from 'vue';
import { createRouter, createWebHistory } from 'vue-router';
import Injector from '@agritask/js-utils/libs/inject/Injector';
import { getURLsearchParams } from '@agritask/js-utils/libs/url';
import { I18N, LOCALE } from '@/vue/inject/ServiceId';
import LoginPage from '@/vue/pages/LoginPage.vue';
import { initSetup } from '@/vue/setup';
import { createI18nInstance } from '@/vue/vue-i18n';
import { DEFAULT_LANGUAGE_CODE } from '../state_management/generalStore';
import { routes } from './routes';
const router = createRouter({
    history: createWebHistory(`${window.tms_context_path?.replaceAll('/', '')}/login`),
    routes,
});
const app = createApp(LoginPage);
app.use(router);
// TODO: PLAT-3113 Initialize language according to some logic
app.provide('context', { context: window.tms_context_path });
const urlParams = getURLsearchParams(window.location.search);
const lang = urlParams.lang || DEFAULT_LANGUAGE_CODE;
initInjector(app, lang);
initSetup(app);
app.mount('#login-app');
function initInjector(app, language) {
    Injector.bindToConstantValue(I18N, createI18nInstance(app, language));
    Injector.bindToConstantValue(LOCALE, language);
}
